module.exports = __webpack_public_path__ + "static/DDWingsLogo-2f09f39dfc6f57e3eb99ee119b1f3f10.svg";